import { CS } from "../../../../../base/utils/styler";

export const gridStyle: CS = {
    display: 'grid',
    gridTemplateColumns: '3fr 7fr',
    gridGap: '1rem',
    flexDirection: 'row-reverse',
    direction: 'rtl',
    width: '100%',
}

export const editorStyle: CS = {
    width: '100%',
    height: '500px'
}

export const submitStyle: CS = {
    zIndex: '1000',
    margin: '20px',
    minWidth: '200px',
    textAlign: 'center',
    position: 'fixed',
    bottom: '10px',
    left: '10px',
}